export default __webpack_public_path__ + "static/media/C1.b00f6de1.jpg";